export default {
  overview: {
    title: "Lieferanten Übersicht",
    subtitle: "Auflistung aller Lieferanten.",
    archive_title: "Archivierte Lieferanten",
    actions: {
      create_new: "Neuen Lieferanten erstellen",
    },
    search: {
      placeholder: "bspw. Name oder Ort",
    },
    table: {
      headers: {
        name: "Lieferant",
        contact: "Ansprechpartner",
      },
      more_contacts: "+{count} weitere",
    },
  },
  detail: {
    title: "Lieferant",
    actions: {
      update: "Speichern",
    },
    tabs: {
      general: "Allgemein",
      contacts: "Ansprechpartner",
      locations: "Standorte",
      assortment: "Sortiment",
      files: "Dateiablage",
      activity: "Protokoll",
    },
    form: {
      name: "Name",
      kind: "Art",
      telephoneNumber: "Telefon",
      email: "E-Mail",
      website: "Website",
      customerNumber: "Unsere Kundennummer",
      address_search_unavailable_hint: "Tragen Sie die Anschrift in die Felder unten ein.",
      sections: {
        base_data: "Stammdaten",
        contact: "Kontakt",
        // Die Anschrift des Lieferanten selbst; weitere Adressen sind seine Standorte.
        address: "Hauptsitz",
        conditions: "Konditionen",
        note: "Notiz",
      },
      contacts: {
        title: "Ansprechpartner",
        subtitle: "Ansprechpartner beim Lieferanten",
        empty: "Noch keine Ansprechpartner.",
      },
    },
  },
  create: {
    title: "Lieferant Anlegen",
    subtitle: "Neuen Lieferanten anlegen.",
  },
  kind: {
    manage: "Arten verwalten",
    no_results: "Keine passende Art gefunden.",
    overview: {
      title: "Arten von Lieferanten",
      subtitle: "Wonach sich Lieferanten unterscheiden lassen, z. B. Baustoffhandel oder Mietpark.",
      empty_items: "Noch keine Arten angelegt.",
      add_item: "Art hinzufügen",
    },
  },
  // Preise der Lieferanten an Maschinen und Material (docs/suppliers.md, „Prices“). Namen und Daten stehen nie in
  // Parametern: das Bundle maskiert sie („Müller &amp; Co“), die Komponenten setzen sie selbst dazu.
  prices: {
    valid_from_window: "Nur 2000 bis 2100",
    // „Gilt ab heute · anderes Datum“: the day a new price holds from, a field only on request.
    valid_from_today: "Gilt ab heute",
    valid_from_other: "anderes Datum",
    valid_from: "Gilt ab",
    // A price cleared from a day on: a state, said rather than dashed out.
    no_price: "ohne Preis",
    // "Preis ändern" an einer Zeile im Einkauf der Maschine oder des Materials.
    change: {
      title: "Preis ändern",
      action: "Preis ändern",
      submit: "Speichern",
      currency: "Währung",
      price: "Neuer Preis",
      // Vor dem bisherigen Preis, im Code angehängt: „Bisher 13,80 EUR / t“.
      before: "Bisher",
      none_before: "Bisher kein Preis in dieser Währung",
      // Vor Datum und Preis eines schon eingetragenen späteren Preises: „Schon eingetragen ab 01.12.2026: 14,50 EUR“.
      upcoming: "Schon eingetragen ab",
    },
    add: {
      title: "Preis hinzufügen",
      submit: "Hinzufügen",
      supplier: "Lieferant",
      // Unter dem Feld, wenn ein getippter Name als neuer Lieferant gewählt ist.
      new_supplier: "Neuer Lieferant, wird mit dem Preis angelegt",
      qualifier: "Zusatz",
      currency: "Währung",
      price: "Preis",
      article_number: "Artikelnummer beim Lieferanten",
      // Maschinen: die Einheit, in der der Lieferant diese Zeile abrechnet (Stunde, Tag, Woche, Monat).
      unit: "Abrechnung je",
    },
    // „Zeile bearbeiten“ im Menü einer Zeile (Einkauf, Sortiment): Zusatz, Artikelnummer, bei Maschinen die Einheit.
    edit_row: {
      action: "Zeile bearbeiten",
      title: "Zeile bearbeiten",
      submit: "Speichern",
      // Unter „Abrechnung je“, sobald eine andere Einheit gewählt ist; {unit} ist ihr Name („Woche“).
      unit_changed: "Alle Preise der Zeile gelten dann je {unit}. Gebuchte Berichte bleiben bis „Umstellen“.",
    },
    // Mehrere Maschinen oder Materialien auf einmal ins Sortiment, je mit ihrem ersten Preis.
    add_items: {
      title_material: "Materialien hinzufügen",
      title_machine: "Maschinen hinzufügen",
      pick_material: "Material suchen",
      pick_machine: "Maschine suchen",
      none_material: "Noch kein Material ausgewählt",
      none_machine: "Noch keine Maschine ausgewählt",
      submit_count: "{count} hinzufügen",
    },
    // Ein Lieferant, der für das Material schon einen Preis hat (Sortiment: „Material hinzufügen“; Einkauf: „Preis
    // hinzufügen“): in der Suche unter dem Namen, unter der Zeile die Zusätze, die es schon gibt („Schon im Sortiment:
    // ohne Zusatz, „Big Bag“.“; im Code zusammengesetzt).
    taken: {
      in_assortment: "Schon im Sortiment",
      without_qualifier: "ohne Zusatz",
      // Ein Zusatz in der Aufzählung: „Big Bag“.
      quoted: "„{qualifier}“",
      second_price:
        "Für einen zweiten Preis einen anderen Zusatz angeben. Nur ein neuer Preis? „Preis ändern“ an der Zeile.",
      qualifier_needed: "Zusatz nötig",
      qualifier_taken: "Gibt es schon",
    },
    // Unter dem Einkaufspreis, wenn ein Material oder eine Maschine ins Projekt kommt: wessen Preis das ist.
    source: {
      standard: "Standard",
      project: "für dieses Projekt",
      change: "Ändern",
      change_label: "Lieferant für dieses Projekt",
      // Die Zeile unter dem Verkaufspreis (Projekt, Kunde), im Code ergänzt: „Einkauf bei Betonwerk Donautal · Ändern“.
      bought_at: "Einkauf bei",
      none: "Noch kein Lieferant",
      // Ohne Recht, die Wahl zu ändern: öffnet dieselbe Liste zum Ansehen.
      all: "Alle Lieferanten",
    },
    overview: {
      typical: "In der Regel",
      range: "{from} – {to} bei 1 Lieferant | {from} – {to} bei {count} Lieferanten",
      suppliers: "Lieferanten",
      add: "Preis hinzufügen",
      empty: "Noch kein Lieferant.",
      make_default: "Als Standard verwenden",
      upcoming: "ab",
      also: "auch {prices}",
      archived: "archiviert",
      history: "Verlauf",
      open_supplier: "Lieferant öffnen",
      // The "Abstand" of the default itself (what the others are measured against), and of a row that shares no
      // currency with it.
      deviation_base: "Basis",
      deviation_other_currency: "andere Währung",
      // Eine Maschinenzeile, die nicht in die Einheit des Standards umzurechnen ist (Stunde gegen Tag/Woche/Monat).
      deviation_other_unit: "andere Einheit",
      // Vor einer Einheit, im Code angehängt: „−17 % (je Tag)“.
      per: "je",
      // Eine Beispielmenge, nichts wird gespeichert: füllt die Spalte „Frei Baustelle bei 10 t“.
      quantity: "Vergleichsmenge",
      effective: "Frei Baustelle",
      // Beim Material neben der Vergleichsmenge: geliefert (mit Fracht) oder selbst abgeholt (ohne), dann „Ab Lager“.
      delivery: "Lieferung",
      pickup: "Abholung",
      effective_pickup: "Ab Lager",
      at_quantity: "bei",
      // Nach „bei“ und „ab“ eine Anzahl einer Maschineneinheit, im Code angehängt: „bei 12 Tagen“.
      unit_count: {
        HOUR: "Stunde | Stunden",
        DAY: "Tag | Tagen",
        WEEK: "Woche | Wochen",
        MONTH: "Monat | Monaten",
      },
      tiers_from: "Staffel ab",
      discount: "−{percent}\u00a0% Rabatt",
      freight: "+\u00a0{amount} Fracht",
      freight_unknown: "Fracht nur in anderer Währung",
      cash_discount: "−{percent}\u00a0% Skonto",
      // Eine Mietmaschine: die Fracht zählt nicht, der Transporttarif des Lieferanten kommt dazu.
      plus_transport: "zzgl. Transport",
      columns: {
        supplier: "Lieferant",
        price: "Preis",
        deviation: "Abstand",
      },
    },
    revisions: {
      title: "Preisverlauf",
      valid_from: "Gilt ab",
      price: "Preis",
      recorded: "Erfasst",
      tiers: "Staffelpreise",
      upcoming: "kommt noch",
      sources: {
        SETUP: "Bei der Einrichtung",
        AUDIT_BACKFILL: "Aus dem Protokoll",
        SORTIMENT: "Im Sortiment",
        DIALOG: "Beim Hinzufügen",
        IMPORT: "Preisliste importiert",
        RECORD_EDIT: "In den Stammdaten geändert",
      },
      remove: {
        title: "Preis entfernen?",
        text: "Der Eintrag verschwindet aus dem Verlauf. War es der gültige Preis, gilt wieder der Preis davor.",
      },
      // Am ausgegrauten 🗑 des einzigen Preises: warum er bleibt.
      only_price_row: "Einziger Preis: stattdessen die Zeile entfernen",
      only_price_accessory: "Einziger Preis: stattdessen das Zubehör entfernen",
    },
    // The column a list of one kind names its records by.
    kind: {
      MATERIAL: "Material",
      MACHINE: "Maschine",
    },
    tiers: {
      title: "Staffelpreise",
      from: "Ab Menge",
      price: "Preis",
      add: "Staffelpreis hinzufügen",
      positive: "Größer als 0",
      increasing: "Größer als die Staffel davor",
      from_short: "ab",
    },
    price_list: {
      title: "Preise ändern",
      valid_from: "Neue Preise gelten ab",
      currency: "Währung",
      partial: "Die Liste konnte nicht vollständig geladen werden.",
      more: "1 weiterer Eintrag – über den Filter erreichbar | {n} weitere Einträge – über den Filter erreichbar",
      current: "Aktuell",
      new: "Neu",
      changed: "Keine Änderung | 1 Preis geändert | {count} Preise geändert",
      submit: "Übernehmen",
    },
    assortment: {
      title: "Sortiment",
      materials: "Materialien",
      machines: "Maschinen",
      filter_materials: "Materialien filtern",
      filter_machines: "Maschinen filtern",
      price_list: "Preise ändern",
      add_material: "Material hinzufügen",
      add_machine: "Maschine hinzufügen",
      open_machine: "Maschine öffnen",
      open_material: "Material öffnen",
      default: "Standard-Lieferant",
      article: "Art.-Nr.",
      empty: "Dieser Lieferant liefert hier noch nichts.",
      no_match: "Nichts gefunden.",
      not_set_up: "Das Sortiment gibt es, sobald die Einkaufspreise Lieferanten zugeordnet sind.",
      columns: {
        price: "Preis",
      },
      remove: {
        action: "Aus dem Sortiment entfernen",
        title: "Lieferant entfernen",
        text: "Der Preis dieses Lieferanten wird entfernt. Projekte behalten ihre Kopie, der Preisverlauf bleibt erhalten.",
        agree: "Entfernen",
      },
    },
  },
  // Objektpreise: der Sonderpreis eines Lieferanten für ein Projekt, mit „gilt ab“ (docs/suppliers.md). Namen, Daten
  // und Preise setzen die Komponenten selbst dahinter, nie als Parameter.
  object_prices: {
    // Am Projekt hinter dem Preis einer Zeile: „102,46 EUR / m³ Objektpreis ✎“.
    marker: "Objektpreis",
    // Vor dem Tag eines Objektpreises, im Code ergänzt: „ab 09.09.2026“.
    valid_from: "ab",
    add: "Objektpreis hinzufügen",
    edit: "Objektpreis bearbeiten",
    remove: "Entfernen",
    dialog: {
      title_add: "Objektpreis hinzufügen",
      title_edit: "Objektpreis bearbeiten",
      submit_add: "Hinzufügen",
      submit_edit: "Speichern",
      supplier: "Lieferant",
      qualifier: "Zusatz (optional)",
      price: "Preis",
      note: "Angebots- oder Objektnummer (optional)",
      // Unter dem Preis, im Code ergänzt: „Lieferant heute 918,00 EUR / t“.
      supplier_today: "Lieferant heute",
      // Beim Bearbeiten, wenn danach schon ein weiterer geplant ist, im Code ergänzt:
      // „Danach ab 01.11.2026: 117,80 EUR / m³ · bearbeiten“.
      next: "Danach",
      edit_next: "bearbeiten",
      remove_title: "Objektpreis entfernen?",
      remove_text: "Gebuchte Berichte behalten ihren Preis. Neue buchen den Preis des Lieferanten.",
    },
    // Im Einkauf und im Sortiment unter einer Zeile: „Objektpreise: Kita Regensburg 860,00 EUR, Wohnanlage Süd
    // 845,00 EUR + 2“.
    in_projects: "Objektpreis: | Objektpreise:",
    more: "+ {n}",
    // Was „+ 2“ öffnet: alle Objektpreise der Zeile, je Projekt.
    all: {
      title: "Objektpreise",
      // Im ⋮ einer Zeile mit Objektpreisen (Einkauf, Sortiment).
      action: "Objektpreise",
      project: "Projekt",
    },
  },
  // Mieten (docs/suppliers.md, „Mieten“): Anlieferung bis Abholung eines gemieteten Geräts, am Projekt im Reiter
  // Maschinen und an der Maschinenzeile im Bericht. Daten, Namen und Beträge setzt der Code dahinter.
  // Zubehör an der Lieferantenzeile einer Maschine (docs/suppliers.md, „Zubehör“): je Eintrag ein Name und datierte
  // Preise, jeder in seiner Einheit. Namen, Daten und Preise setzen die Komponenten selbst dahinter.
  accessories: {
    // Im Menü ⋮ der Lieferantenzeile einer Maschine; je Zubehör eine kompakte Zeile darunter.
    add: "Zubehör hinzufügen",
    // Vor der Einheit, im Code ergänzt: „je Tag“.
    per: "je",
    // Spalte im Preisverlauf eines Zubehörs.
    columns: {
      unit: "Abrechnung",
    },
    // Beim Entfernen der letzten Zeile eines Lieferanten an einer Maschine, hinter dem Text der Rückfrage.
    remove_with_row: "Es ist seine letzte Zeile an dieser Maschine: Sein Zubehör für sie wird mit entfernt.",
    remove: {
      action: "Entfernen",
      title: "Zubehör entfernen",
      text: "Mieten, die es mitnehmen, behalten Namen und Preis.",
      agree: "Entfernen",
    },
    dialog: {
      title_add: "Zubehör hinzufügen",
      // Name und Preis in einem Dialog, aus ✎ und ⋮ der Zeile.
      title_edit: "Zubehör bearbeiten",
      submit_add: "Hinzufügen",
      submit_edit: "Speichern",
      name: "Name",
      // Überschrift über Währung, Abrechnung, Preis und „Gilt ab“: der Preis gilt ab einem Tag, der Name sofort.
      price: "Preis",
      name_length: "Höchstens 120 Zeichen",
    },
  },
  rentals: {
    title: "Mieten",
    add: "Miete hinzufügen",
    empty: "Noch keine Miete. Anlegen hier oder zum Mietbeginn an der Maschine im Bericht.",
    edit: "Miete bearbeiten",
    // „läuft seit 05.10.“
    running_since: "läuft seit",
    // Noch nicht angeliefert: „ab 05.11.“
    from: "ab",
    // Läuft noch, neben dem Chip „läuft“: „seit 05.10.“
    since: "seit",
    running: "läuft",
    // An einer laufenden Miete: ihr Ende mit Tag und Rücktransport, im kleinen Dialog des Berichts.
    pick_up: "Miete beenden",
    // Die Spalten im Kopf einer Miete, wie Einkaufs- und Verkaufspreis der Maschinen darüber.
    period: "Zeitraum",
    cost: "Kosten",
    // Aufgeklappt: woraus die Kosten bestehen.
    breakdown: {
      rent: "Miete",
      note: "Notiz",
    },
    // Hinter dem Mietpreis, wenn er ein Objektpreis des Projekts ist.
    object_price: "Objektpreis",
    // Abgerechnete Menge, ohne die Einheit davor: „2 angefangene Wochen“, „5 Tage“, „12,5 Stunden“
    quantity: {
      DAY: "1 Tag | {n} Tage",
      WEEK: "1 angefangene Woche | {n} angefangene Wochen",
      MONTH: "1 angefangener Monat | {n} angefangene Monate",
      HOUR: "1 Stunde | {n} Stunden",
    },
    // Ein Standort, den der Lieferant nicht mehr hat: „Mietpark Nord (Standort entfernt)“
    location_removed: "Standort entfernt",
    // Die Fahrten des Lieferanten: zum Mietbeginn bringt er das Gerät, zum Mietende holt er es.
    kinds: {
      DELIVERY: "Anlieferung",
      PICKUP: "Abholung",
    },
    // Dieselben Fahrten, wenn der Betrieb selbst fährt: kein „Anlieferung selbst“.
    self_kinds: {
      DELIVERY: "Selbst geholt",
      PICKUP: "Selbst zurückgebracht",
    },
    // Tage der Miete ohne Einsatz, als Chips: „So 25.10. · 10 %“, „Sa 24.10. · frei“, „So 01.11. · Allerheiligen · 10 %“.
    idle: {
      label: "Ohne Einsatz",
      // Im Tages-Popover der Kosten: „Miete · ohne Einsatz 10 % · Mietpark Nord“
      short: "ohne Einsatz",
      title: "Tage ohne Einsatz",
      free: "frei",
      // Ein Feiertag, dessen Namen die Antwort nicht nennt.
      holiday: "Feiertag",
      // Klappt die übrigen Chips einer langen Miete auf: „+5“.
      more: "+{n}",
      less: "weniger",
      // Im Dialog unter den Chips: „Zusammen 836,00 EUR · Feiertage: Bayern“
      total: "Zusammen",
      region: "Feiertage",
      nationwide: "bundesweit",
      // In der Kostenansicht: „4 Tage ohne Einsatz · 836,00 EUR“
      count: "1 Tag ohne Einsatz | {n} Tage ohne Einsatz",
      regions: {
        BW: "Baden-Württemberg",
        BY: "Bayern",
        BE: "Berlin",
        BB: "Brandenburg",
        HB: "Bremen",
        HH: "Hamburg",
        HE: "Hessen",
        MV: "Mecklenburg-Vorpommern",
        NI: "Niedersachsen",
        NW: "Nordrhein-Westfalen",
        RP: "Rheinland-Pfalz",
        SL: "Saarland",
        SN: "Sachsen",
        ST: "Sachsen-Anhalt",
        SH: "Schleswig-Holstein",
        TH: "Thüringen",
      },
    },
    // „Anlieferung 6 × 15 min“, „Abholung selbst“, „Anlieferung 1 Fahrt“; ohne bekannte Minuten „6 Zeiteinheiten“.
    time_units: "Zeiteinheit | Zeiteinheiten",
    trip: "1 Fahrt",
    self: "selbst",
    gaps: {
      NO_PRICE: "Kein Preis",
      NO_WEIGHT: "Transportgewicht fehlt",
      NO_TARIFF: "Kein Tarif",
      NO_CLASS: "Keine Gewichtsklasse",
      NO_CURRENCY: "Tarif ohne Preis in dieser Währung",
      NO_TIME_UNITS: "Dauer fehlt",
    },
    // Zubehör an der Miete (Tieflöffel, Hammer): „Zubehör: Tieflöffel 60 cm × 1 · 150,00 EUR“.
    accessories: {
      title: "Zubehör",
      add: "Zubehör hinzufügen",
      pick: "Zubehör",
      none: "Kein Zubehör gefunden",
      // Am Ende der Auswahl: ein neues des Mietlieferanten für die Maschine, mit dem getippten Namen.
      create_new: "Neues Zubehör anlegen …",
      create_named: "„{name}“ als Zubehör anlegen …",
      create_at: "beim Lieferanten der Miete",
      quantity: "Menge",
      remove: "Zubehör entfernen",
      // Eines, das der Lieferant nicht mehr führt: die Miete behält Namen und Preis.
      removed: "beim Lieferanten entfernt",
      quantity_range: "Über 0 bis 9.999, höchstens zwei Nachkommastellen",
      // Im Kostenverlauf: „Miete 2.500,00 EUR · Zubehör 150,00 EUR · Transport 288,75 EUR“
      cost: "Zubehör",
      // Im Protokoll: „Zubehör Menge: 2“
      audit: "Zubehör",
    },
    dialog: {
      title_add: "Miete hinzufügen",
      title_edit: "Miete bearbeiten",
      submit_add: "Hinzufügen",
      submit_edit: "Speichern",
      machine: "Maschine",
      device: "Gerät",
      row: "Einkaufspreis",
      row_hint: "Zu welchem Preis wird gemietet?",
      location: "Standort",
      head_office: "Hauptsitz",
      // Beginn und Ende einer Miete, wer auch fährt: der Lieferant („durch Lieferant“) oder der Betrieb („selbst“).
      delivery: "Mietbeginn",
      pickup: "Mietende (optional)",
      end: "Mietende",
      date: "Datum",
      by_supplier: "durch Lieferant",
      self: "selbst",
      // Wie viele Zeiteinheiten die Fahrt kostet, mit „× 15 min“ dahinter.
      time_units: "Dauer",
      time_units_range: "0 bis 999, höchstens zwei Nachkommastellen",
      note: "Notiz (Mietvertrag, Lieferschein)",
      // Unter der Zeile: „Preis 1.250,00 EUR / Wo vom 05.10.2026 · Preis neu lesen“
      price: "Preis",
      price_of: "vom",
      object_price: "Objektpreis",
      reprice: "Preis neu lesen",
      repricing: "Wird gelesen …",
      before_delivery: "Liegt vor dem Mietbeginn",
      no_machines: "Das Projekt hat noch keine Maschine.",
      // Auch, wenn sie nur zum Eigenen Betrieb einen hat: der eigene Bestand wird nicht gemietet.
      no_row: "Die Maschine hat keinen Einkaufspreis eines Lieferanten.",
      remove: "Entfernen",
      remove_title: "Miete entfernen?",
      remove_text: "Ihre Kosten fallen weg, die Berichte rechnen das Gerät wieder selbst.",
    },
    // Im Protokoll einer Miete.
    audit: {
      running: "läuft noch",
      note: "Notiz",
      gap: "Lücke",
      basis: "Tarif",
      weight: "Transportgewicht",
      days_per_unit: "Miettage je Einheit",
      // Hinter „Transport“: der Tarif, aus dem der Preis kommt (sein Gültig-ab), und der Tag, an dem er gelesen wurde.
      tariff_from: "Tarif gültig ab",
      price_date: "Preis vom",
      // „Ohne Einsatz Sonn- und Feiertag: 10 %“
      idle: "Ohne Einsatz",
      source: "Preis",
      mode: "Preis aus",
      sources: {
        BOOKED: "zum Mietbeginn gelesen",
        REPRICED: "neu gelesen",
      },
    },
    // An der Maschinenzeile eines Berichts.
    report: {
      delivery: "Mietbeginn",
      in_rental: "Miete",
      since: "seit",
      pick_up: "Miete beenden",
      title_delivery: "Mietbeginn",
      title_pickup: "Mietende",
      submit_delivery: "Miete anlegen",
      // Bei einer Anlieferung aus dem Bericht: bei welchem Lieferanten (welcher Zeile) gemietet wird.
      rented_from: "Gemietet bei",
      submit_pickup: "Miete beenden",
      // „Die Miete beginnt am 05.10.2026.“
      starts_on: "Die Miete beginnt am",
      ends_on: "Die Miete endet am",
      saved_at_once: "Das wird sofort gespeichert, der Bericht erst mit „Speichern“.",
    },
  },
  // Buchungen von Zeilen, die dem Lieferanten folgen, noch zu einem älteren Preis (docs/suppliers.md, „Umstellen“).
  // Daten und Preise setzt die Komponente selbst dahinter.
  following: {
    bookings: "1 Buchung | {n} Buchungen",
    projects: "in 1 Projekt | in {n} Projekten",
    since: "seit",
    still_at: "noch zu",
    still_older: "noch zu älteren Preisen",
    // Was „Umstellen“ am Einkauf ändert, wie die Summe der Rückfrage; Betrag im Code: „Einkauf + 13,50 EUR“.
    cost_change: "Einkauf",
    unreachable: "1 weiteres Projekt ohne Berechtigung | {n} weitere Projekte ohne Berechtigung",
    // Öffnet die Rückfrage; erst deren „Umstellen“ schreibt.
    switch: "Auf Preise ihres Tages umstellen …",
    // Am Einkauf eines Projekts: nur dieses Material oder diese Maschine dort, sofort.
    switch_item: "Umstellen",
    switching: "Wird umgestellt …",
    // Die Rückfrage: je Projekt die Buchungen und ihr Einkauf bisher und danach. Beträge setzt die Komponente dahinter.
    dialog: {
      title: "Buchungen umstellen",
      text: "Die Buchungen bekommen den Einkaufspreis, der an ihrem Tag gilt. Abgerechnete Stundenlohnarbeiten behalten ihre Preise; jeder geänderte Bericht steht im Protokoll.",
      project: "Projekt",
      bookings: "Buchungen",
      since: "ab",
      before: "Einkauf bisher",
      after: "Einkauf neu",
      total: "Gesamt",
      not_switched: "wird nicht umgestellt | werden nicht umgestellt",
      submit: "Umstellen",
    },
    done: "Keine Buchung umgestellt | 1 Buchung umgestellt | {n} Buchungen umgestellt",
    skipped: "1 Bericht übersprungen, er wurde gerade geändert | {n} Berichte übersprungen, sie wurden gerade geändert",
  },
  conditions: {
    discount: {
      title: "Rabatt",
      info: "Senkt jeden gebuchten Preis dieses Lieferanten, auch Staffelpreise. Eine Änderung gilt ab heute; Buchungen früherer Tage behalten ihren Rabatt.",
      valid_from: "Gilt ab",
      percent: "Rabatt",
      add: "Rabatt hinzufügen",
      current: "gilt heute",
      upcoming: "kommt noch",
      past: "abgelöst",
      same_day: "Für diesen Tag gibt es schon einen Rabatt",
      // Öffnet die Liste mit Datum (ein Rabatt ab einem späteren Tag oder rückwirkend); das Feld selbst gilt ab heute.
      dated: "ab anderem Datum …",
    },
    cash_discount: {
      title: "Skonto",
      percent: "Skonto",
      days: "Bei Zahlung innerhalb",
      days_suffix: "Tagen",
    },
    freight: {
      title: "Fracht",
      currency: "Währung",
      per_delivery: "Kosten pro Lieferung",
      free_from: "Frei ab Warenwert",
      note: "Notiz zur Fracht",
    },
    // Miettage je Woche und Monat: rechnen Preise je Woche oder Monat in Tage um. Leer gilt 5 und 20.
    rental: {
      title: "Miete",
      info: "Rechnet Preise je Woche oder Monat in Tage um: im Vergleich und für gebuchte Einsatztage (2 von 5 Miettagen = 0,4 Wochen). Die Miettage entscheiden auch, wie viele angefangene Wochen oder Monate eine Miete kostet.",
      week: "Woche",
      month: "Monat",
      days_suffix: "Miettage",
      // Hinter „Woche = 5 Miettage, Monat = 20 Miettage“; öffnet den Dialog.
      change: "ändern",
      days_title: "Miettage",
      week_range: "1 bis 7 Miettage",
      month_range: "1 bis 31 Miettage",
      // Blendet Miete und Transport ein, bei einem Lieferanten ohne Maschinen im Sortiment und ohne eigene Konditionen.
      open: "Miete und Transport",
      // Was ein Miettag ohne Einsatz des Geräts kostet, in Prozent des Tagessatzes
      // (docs/suppliers.md, „Tage ohne Einsatz“).
      idle: {
        title: "Tage ohne Einsatz",
        info: "Anteil am Tagessatz, den ein Miettag ohne Einsatz kostet (bei Stundenpreis 8 Std.). Erster und letzter Miettag zählen voll, Feiertage nach dem Bundesland der Baustelle.",
        weekdayPercent: "Werktag",
        saturdayPercent: "Samstag",
        sundayHolidayPercent: "Sonn- und Feiertag",
        range: "0 bis 100 %",
      },
    },
    // Am Skonto, für Skonto und Fracht.
    not_booked:
      "Skonto und Fracht werden nicht gebucht. Sie zählen nur im Einkauf einer Maschine oder eines Materials, sobald dort eine Menge eingetragen ist: dann zeigt er den Preis frei Baustelle.",
    percent_range: "Von 0 bis unter 100 %",
    days_range: "0 bis 365 Tage",
  },
  // Standorte: weitere Adressen des Lieferanten mit eigenen Ansprechpartnern (docs/suppliers.md, „Standorte“).
  locations: {
    title: "Standorte",
    info: "Weitere Adressen des Lieferanten, etwa Filialen oder Lager, mit eigenen Ansprechpartnern. Sie teilen seine Preise; eine Filiale mit eigenen Preisen legen Sie als eigenen Lieferanten an.",
    // Hinter Art und Ort in der Übersicht und der Auswahl: „Mietpark · 12355 Musterstadt · +1 Standort“.
    more: "+1 Standort | +{n} Standorte",
    empty: "Noch keine Standorte.",
    // Wie „Hinzufügen“ der Ansprechpartner im Tab daneben.
    add: "Hinzufügen",
    add_title: "Standort hinzufügen",
    edit_title: "Standort bearbeiten",
    // Ohne Recht zum Bearbeiten: nur lesen.
    view_title: "Standort",
    add_submit: "Hinzufügen",
    edit_submit: "Übernehmen",
    // Im Dialog eines Standorts, über seinen Ansprechpartnern.
    add_contact: "Ansprechpartner hinzufügen",
    name: "Name",
    name_taken: "Diesen Namen hat schon ein Standort",
    address: "Adresse",
    email: "E-Mail Disposition",
    note_length: "Höchstens {max} Zeichen",
    // Unter dem Titel des Kontaktdialogs, der Name des Standorts im Code angehängt.
    contact_subtitle: "Ansprechpartner am Standort",
    columns: {
      name: "Standort",
      email: "Disposition",
    },
    remove: {
      title: "Standort entfernen",
      text: "Der Standort und seine Ansprechpartner sind nach dem Speichern weg.",
      agree: "Entfernen",
    },
  },
  // Transporttarif: Anlieferung und Abholung von Mietmaschinen, nach Zeit oder je Fahrt, nach Gewichtsklasse.
  // Zahlen, Beträge und Tage werden im Code angehängt („Transport bis 10 t: 26,25 EUR je 15 min“).
  transport: {
    title: "Transport",
    info: "Anlieferung und Abholung von Mietmaschinen. Die Klasse wählt das Transportgewicht der Maschine; „bis 10 t“ schließt 10 t ein.",
    add: "Tarif hinzufügen",
    remove: "Tarif entfernen",
    basis: {
      TIME: "nach Zeit",
      TRIP: "je Fahrt",
    },
    per: {
      // Nur ohne bekannte Minuten; sonst „je“ und die Minuten („je 15 min“).
      TIME: "je Zeiteinheit",
      TRIP: "je Fahrt",
    },
    // „je 15 min“: die Zeiteinheit, in der eine Fahrt abgerechnet wird.
    per_time: "je",
    minutes: "min",
    // Das Feld „Abgerechnet je [15] min“, im Protokoll mit der Zahl der Klassen eines Tarifs.
    time_unit: "Abgerechnet je",
    classes: "Klassen",
    columns: {
      weight: "Gewicht",
      price: "Preis",
    },
    up_to: "bis",
    above: "darüber",
    every_weight: "jedes Gewicht",
    add_class: "Klasse hinzufügen",
    toll: "inkl. Maut",
    note: "Notiz zum Transport",
    rules: {
      minutes: "1 bis 240 Minuten",
      weight: "Über 0 bis 1.000 t",
      ascending: "Mehr als die Klasse davor",
    },
    // Unter einer Zeile im Einkauf einer Maschine.
    line: {
      from: "ab",
      over: "über",
      no_price: "kein Preis über",
    },
  },
  archive: {
    title: "Lieferant archivieren?",
    submit: "Archivieren",
    // What archiving means for its prices: the projects keep their copies, new projects get none.
    projects:
      "Die Preise werden neuen Projekten nicht mehr angeboten. | Die Preise bleiben in 1 laufenden Projekt buchbar und werden neuen Projekten nicht mehr angeboten. | Die Preise bleiben in {n} laufenden Projekten buchbar und werden neuen Projekten nicht mehr angeboten.",
    // Laufende Mieten des Lieferanten: sie bleiben, wie sie sind.
    running_rentals: "1 laufende Miete rechnet weiter. | {n} laufende Mieten rechnen weiter.",
    defaults: "Standard bei",
    new_default: "Neuer Standard",
    stays_default: "bleibt Standard – kein anderer Lieferant",
    stays_default_no_right: "bleibt Standard (ohne Recht, Einkaufspreise zu ändern)",
  },
  setup: {
    title: "Lieferanten einrichten",
    subtitle: "Jeder Einkaufspreis gehört künftig zu einem Lieferanten. Ordnen Sie die bisherigen Bezeichnungen zu.",
    // Nach der Einrichtung, für Preise, die seither ohne Lieferant geschrieben wurden.
    subtitle_after: "Ordnen Sie die Bezeichnungen der Einkaufspreise ohne Lieferant zu.",
    hint: "Lieferanten einrichten",
    invitation_empty:
      "Die Lieferantenverwaltung ist noch nicht eingerichtet. Ordnen Sie Ihre Einkaufspreise einmal Lieferanten zu.",
    invitation_leftovers:
      "1 Einkaufspreis gehört noch keinem Lieferanten. | {n} Einkaufspreise gehören noch keinem Lieferanten.",
    labels: "Bisherige Bezeichnungen",
    unnamed: "Ohne Bezeichnung",
    no_labels: "Keine Einkaufspreise zuzuordnen. Mit „Einrichten“ ist die Lieferantenverwaltung startklar.",
    settled: "Alle Einkaufspreise gehören einem Lieferanten.",
    leftovers:
      "1 Preis ist während der Einrichtung ohne Lieferant hinzugekommen. Bitte noch einmal zuordnen. | {n} Preise sind während der Einrichtung ohne Lieferant hinzugekommen. Bitte noch einmal zuordnen.",
    type_new: "Oder einen neuen Namen eintippen",
    own_company: "Eigener Betrieb",
    new_prefix: "Neu:",
    columns: {
      label: "Bezeichnung",
      used: "Verwendet",
      supplier: "Wird zu",
    },
    used: {
      machines: "1 Maschine | {n} Maschinen",
      materials: "1 Material | {n} Materialien",
      projects: "1 Projektpreis | {n} Projektpreise",
      bookings: "1 Buchung | {n} Buchungen",
    },
    preview: {
      action: "Vorschau",
      new_suppliers:
        "Es wird kein neuer Lieferant angelegt. | 1 Lieferant wird neu angelegt. | {count} Lieferanten werden neu angelegt.",
      collisions:
        "Bei 1 Maschine oder einem Material landen zwei Preise beim selben Lieferanten; die bisherige Bezeichnung wird zum Zusatz: | Bei {n} Maschinen und Materialien landen zwei Preise beim selben Lieferanten; die bisherige Bezeichnung wird zum Zusatz:",
    },
    apply: "Einrichten",
    confirm: {
      title: "Lieferanten einrichten?",
      text: "Danach gehört jeder Einkaufspreis zu einem Lieferanten, und Preise werden beim Lieferanten gepflegt.",
    },
    done: {
      title: "Lieferanten eingerichtet",
      suppliers: "Kein Lieferant neu angelegt. | 1 Lieferant neu angelegt. | {n} Lieferanten neu angelegt.",
      rows: "Kein Preis zugeordnet. | 1 Preis zugeordnet. | {n} Preise zugeordnet.",
      to_suppliers: "Zu den Lieferanten",
    },
  },
  component: {
    autocomplete: {
      no_data: "Kein Lieferant „{value}“ gefunden.",
      // Am Ende der Auswahl, mit dem getippten Namen; angelegt wird erst mit dem, was der Dialog hinzufügt.
      create: "„{name}“ als neuen Lieferanten anlegen",
      create_later: "Weitere Angaben später beim Lieferanten",
    },
  },
}
